import dayjs from 'dayjs';

dayjs.locale('ja');

export default {
  data() {

  },
  methods: {
    isSquareMater(val, sep = '-') {
      return val !== undefined ? val.replace(/m2/g, '').replace(/㎡/g, '') : sep;
    },
    isDateFormated(val) {
      return dayjs(val).format('YYYY年MM月DD日');
    },
    isValued(val, sep = '-') {
      return val !== undefined ? val : sep;
    },
    isValuedKind(val, sep = '-') {
      let ret = sep;
      if (val === 'newly-house' || val === '新築一戸建て') {
        ret = '新築一戸建て';
      } else if (val === 'second-hand-house' || val === '中古一戸建て') {
        ret = '中古一戸建て';
      }

      return ret;
    },
    imageRender(url) {
      return url;
    },
    dateFormated(val, format) {
      return dayjs(val).format(format);
    },
  },
};
